import type { Swiper as SwiperClass } from 'swiper/types';

/**
 * Безопасно разрушает инстанс Swiper, если он ещё существует.
 */
export const safeDestroySwiper = (instance?: SwiperClass | null) => {
  if (!instance || (instance as any).destroyed) return;

  try {
    instance.destroy(true, true);
  } catch (error) {
    console.warn('Safe destroy swiper error:', error);
  }
};
